import React from 'react';
import GetTAF from './test7';

export default function Test() {
  
  return (
    <>
    <div className='taf'>
    <p>TAFS</p>
    {GetTAF("EPPW", 0)}
    {GetTAF("EPLY", 0)}
    {GetTAF("EPBY", 1)}

    </div>
    </>
  );
}